<template>
  <side-bar
    v-show="ChannelCreateSidebar === true"
    position-right
    class="z-10 max-w25"
  >
    <div class="flex sidebar-topfixpart bg-primary justify-between p-4">
      <h2 class="h2-class font-semibold text-white">EDIT CHANNEL NAME</h2>

      <feather-icon
        icon="XIcon"
        @click="closeSidebar"
        class="cursor-pointer text-white"
        svgClasses="w-6"
      ></feather-icon>
    </div>
    <div class="p-4">
      <div class="mb-4">
        <FileUploader :onSuccess="loadImage" v-if="!SelectedImage" />
        <!-- <img :src="renderedImage" v-else /> -->
        <Cropper
          class="cropper"
          :src="renderedImage"
          v-if="SelectedImage != ''"
          @change="chnage"
          ref="cropper"
          :default-size="defaultSize"
        />
      </div>

      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Channel Name</p>
        <b-input
          required
          placeholder="Enter Channel Name..."
          v-model="select_channel.name"
        />
        <span v-if="nameErr" class="small text-danger">{{ msg.name }}</span>
      </div>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Channel Description</p>
        <b-input
          required
          placeholder="Enter Channel description..."
          v-model="select_channel.description"
        />
      </div>
      <div class="mb-2">
        <label for="membership">Membership:</label>
        <multiselect
          name="membership"
          v-model="selectedMembership"
          :options="membership"
          :multiple="false"
          :close-on-select="true"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Select Memberships"
          track-by="name"
          label="name"
          :preselect-first="false"
        >
        </multiselect>
      </div>
    </div>

    <footer class="mb-10 mx-4 rounded-md">
      <base-button
        block
        type="primary"
        class="font-semibold"
        @click="editchannel()"
        >Save</base-button
      >
    </footer>
  </side-bar>
</template>
<script>
import { mapState } from "vuex";
import FileUploader from "@/components/FileUploader.vue";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
export default {
  components: {
    FileUploader,
    Cropper,
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      channles: "",
      selecteChannel: {},
      membershipFilter: [],
      selectedMembership: null,
      onlyRegistered: false,
      nameErr: false,
      msg: {},
      SelectedImage: null,
      renderedImage: null,
      cropperImg: "",
    };
  },
  // mounted() {
  //   this.selecteChannel = this.select_channel;
  // },
  computed: {
    ...mapState("UI", ["ChannelCreateSidebar"]),
    ...mapState("channel", ["select_channel"]),
    ...mapState("membership", { membership: "membership" }),
  },
  watch: {
    selecte_Channel(val) {
      this.selecteChannel = { ...val };

      // console.log("hello");
    },
    select_channel(val) {
      this.selectedMembership = val.planId[0];
    },
  },
  methods: {
    async getMembership() {
      let payload = {};
      const data = await this.$store.dispatch(
        "membership/getAllMembership",
        payload
      );
      // console.log({ mem: data });
    },
    async editchannel() {
      let payload = new FormData();
      payload.append("name", this.select_channel.name.trim());
      payload.append("planId", this.selectedMembership._id);
      payload.append("channelID", this.select_channel._id);
      payload.append("description", this.select_channel.description);
      if (this.SelectedImage) {
        payload.append("media", this.SelectedImage);
      }
      if (this.select_channel.name.trim() == "") {
        this.nameErr = true;
        this.msg.name = "Name is required";
      } else {
        const res = await this.$store.dispatch("channel/editChannel", payload);
        // console.log(res);
        if (res.code == 200) {
          //  await  this.$store.dispatch("channel/GetALLChannel");
          this.$swal.fire({
            text: "Channel successfully updated!",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
        let payload2 = {
          limit: 5,
          offset: (this.select_channel.offset - 1) * 5,
        };
        await this.$store.dispatch("admin/getChannel", payload2);
        this.closeSidebar();
      }
    },
    closeSidebar() {
      this.$store.commit("UI/TOGGLE_CHANNEL_CREATE_SIDEBAR", false);
    },
    defaultSize({ imageSize, visibleArea }) {
      return {
        width: (visibleArea || imageSize).width,
        height: (visibleArea || imageSize).height,
      };
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    chnage(img) {
      // console.log(img);
      this.cropperImg = img;
      this.SelectedImage = this.dataURLtoFile(
        img.canvas.toDataURL(),
        "image.png"
      );
    },
    loadImage(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.SelectedImage = image;
      this.readerData(image);
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.renderedImage = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
  },
  async mounted() {
    this.getMembership();
  },
};
</script>
